import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import AnkeilerSmall from './_ankeiler-small/component';
import AnkeilerMedium from './_ankeiler-medium/component';
import AnkeilerList from './_ankeiler-list/component';
import AnkeilerHighlight from './_ankeiler-highlight/component';
import AnkeilerText from './_ankeiler-text/component';
import AnkeilerBasket from './_ankeiler-basket/component';
import AnkeilerInfoBlock from './_ankeiler-info-block/component';
import AnkeilerMinimalList from './_ankeiler-minimal-list/component';
import AnkeilerCampaign from './_ankeiler-campaign/component';
import AnkeilerStores from './_ankeiler-stores/component';
import Link from '@components/base_link/component';
import { Product } from '@utils/product';
import { productClickGoogleTag, promotionClickGoogleTag } from '@utils/analytics.js';

import './styles/styles.scss';

const transMap = {
  default: AnkeilerSmall,
  small: AnkeilerSmall,
  medium: AnkeilerMedium,
  list: AnkeilerList,
  highlight: AnkeilerHighlight,
  text: AnkeilerText,
  basket: AnkeilerBasket,
  minimalList: AnkeilerMinimalList,
  campaign: AnkeilerCampaign,
  stores: AnkeilerStores,
};

/*
 * @TODO: Quick order only works on the compact Ankeiler variant.
 *   - Make this available for other variants in the future.
 */

class Ankeiler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInfo: false,
    };
    this.ref = createRef();
    this.product = new Product(props);
  }

  componentDidUpdate(prevProps) {
    /**
     * Create a new instance of the Product class when the price has changed
     */
    if (JSON.stringify(prevProps?.price) !== JSON.stringify(this.props?.price)) {
      this.product = new Product(this.props);
    }
  }

  get info() {
    const { info } = this.props;
    if (!info) {
      return null;
    }
    return info;
  }

  get variant() {
    return this.props.variant;
  }

  getAnkeilerVariant() {
    return transMap[this.variant] || transMap.default;
  }

  get pushToDataLayer() {
    return this.props.store.pushToDataLayer;
  }

  get infoBlock() {
    const { showInfo } = this.state;
    if (!!showInfo) {
      return (
        <AnkeilerInfoBlock
          {...this.props}
          hideBlock={this.hideInfo}
          parentRef={this.ref}
          product={this.product}
        />
      );
    }
    return null;
  }

  handleClick = (e) => {
    if (!this.info) {
      return;
    }
    e.preventDefault();
    this.setState({ showInfo: true });
  };

  hideInfo = () => {
    this.setState({ showInfo: false });
  };

  googleTagMethods = () => {
    return {
      pushPromotionGoogleTag: (product) => {
        this.pushToDataLayer(promotionClickGoogleTag(product));
      },
      pushProductGoogleTag: (product) => {
        this.pushToDataLayer(productClickGoogleTag({
          product,
          position: this.props.position,
          adviceId: this.props.adviceId,
        }));
      },
    };
  };

  pushGoogleTags = () => {
    this.googleTagMethods()
      .pushProductGoogleTag(this.product);
  };

  get renderTitle() {
    return (
      <Link title={this.product.name} onClick={this.pushGoogleTags} href={this.product.url}>
        <span dangerouslySetInnerHTML={{ __html: this.product.name }}></span>
      </Link>
    );
  }

  render() {
    const AnkeilerVariant = this.getAnkeilerVariant();
    return (
      <span
        className={`ankeiler-wrapper ${this.info ? 'has-info' : ''}`}
        data-test-id="ankeiler"
        onClick={this.handleClick}
        key={this.props.ankeilerKey}
      >
        <AnkeilerVariant
          ref={this.innerRef}
          googleTagMethods={this.googleTagMethods}
          product={this.product}
          {...this.props}
          info={this.props.info}
          infoBlock={this.infoBlock}
          title={this.renderTitle}
        />
      </span>
    );
  }
}

Ankeiler.propTypes = {
  /**
   * String to determine which variant of the ankeiler should render
   */
  variant: PropTypes.string,
  store: PropTypes.object,
  list: PropTypes.any,
  position: PropTypes.number,
  price: PropTypes.object,
  ankeilerKey: PropTypes.string,
  /**
   * Provided by Bookarang in giftPicker component
   */
  adviceId: PropTypes.string,
  info: PropTypes.oneOfType([
    PropTypes.shape({
      quickOrder: PropTypes.bool,
    }),
    PropTypes.bool,
  ]),
};

export default Ankeiler;
